import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zhCN from '@/i18n/zh-CN'
import enUS from '@/i18n/en-US'
import zhTC from '@/i18n/zh-TC'

import { LOCAL_LANGUAGE_KEY } from '@/constant/common'
import _ from 'lodash'

Vue.use(VueI18n)

function getLanguageCode () {
  let language = navigator.browserLanguage || navigator.language
  language = language.toLowerCase()
  if (language === 'zh-cn' || language === 'zh-hans-cn' || language === 'zh-hans') {
    language = 'zh'
  } else if (language.indexOf('zh-hant') > -1 || language.indexOf('hk') > -1) {
    language = 'hk'
  } else if (language.indexOf('-tw') > -1) {
    language = 'tw'
  } else {
    language = 'en'
  }

  language = localStorage.getItem(LOCAL_LANGUAGE_KEY) || language
  localStorage.setItem(LOCAL_LANGUAGE_KEY, language)
  return language
}

function isEn () {
  return i18n.locale === 'en'
}

function getI18nPropertyValue (obj, cnPropertyName, enPropertyName) {
  if (!obj) {
    return obj
  }
  return _.get(obj, isEn() ? enPropertyName : cnPropertyName)
}

function addI18nProperty (obj, propertyName, cnPropertyName, enPropertyName, context = null) {
  if (!obj) {
    return obj
  }
  Object.defineProperty(obj, propertyName, {
    enumerable: true,
    configurable: true,
    get () {
      return getI18nPropertyValue(context || this, cnPropertyName, enPropertyName)
    }
  })
  return obj
}

function createI18nProperty (obj, propertyName, i18nKey, i18nValues, defaultValue) {
  if (!obj || !i18nKey) {
    return obj
  }
  Object.defineProperty(obj, propertyName, {
    enumerable: true,
    configurable: true,
    get () {
      if (i18n.te(i18nKey) || [null, undefined].includes(defaultValue)) {
        return i18n.t(i18nKey, i18nValues)
      }
      return defaultValue
    }
  })
  return obj
}

function selectLabelI18n (obj, labelName, defaultI18nKey, i18nKeyLabelName) {
  labelName = labelName || 'label'
  const value = _.get(obj, labelName)
  if (value) {
    return value
  }
  const i18nKey = _.get(obj, i18nKeyLabelName || `${labelName}I18nKey`) || defaultI18nKey
  return i18nKey && i18n.t(i18nKey)
}

function selectFuncLabelI18n (callbackArgs, obj, labelName, defaultI18nKey, i18nKeyLabelName) {
  labelName = labelName || 'label'
  const labelCallback = _.get(obj, labelName)
  if (typeof labelCallback === 'function') {
    return labelCallback(...callbackArgs)
  } else if (labelCallback !== null && labelCallback !== undefined) {
    return labelCallback
  }
  const i18nKeyCallback = _.get(obj, i18nKeyLabelName || `${labelName}I18nKey`)
  let i18nKey
  if (typeof i18nKeyCallback === 'function') {
    i18nKey = i18nKeyCallback(...callbackArgs)
  } else {
    i18nKey = (i18nKeyCallback === null || i18nKeyCallback === undefined) ? defaultI18nKey : i18nKeyCallback
  }
  return i18nKey && i18n.t(i18nKey)
}

function switchLanguageWithZhAndEn () {
  i18n.locale = isEn() ? 'zh' : 'en'
}

function getConstantI18nValue (constant, value, i18nPrefix) {
  const i18nKey = _.findKey(constant, item => item === value)
  if (!i18nKey) {
    return value
  }
  return i18n.t(`${i18nPrefix}.${i18nKey}`)
}

const i18n = new VueI18n({
  locale: getLanguageCode(),
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: {
    zh: zhCN,
    en: enUS,
    tw: zhTC,
    hk: zhTC
  }
})

/**
 * @example used in vue:
 *  this.$t('xxx.xxx')
 * @example used in js:
 *  import i18n from '@i18n'
 *  i18n.t('xxx.xxx')
 */
export default i18n
export {
  getLanguageCode,
  isEn,
  getI18nPropertyValue,
  addI18nProperty,
  selectLabelI18n,
  selectFuncLabelI18n,
  createI18nProperty,
  switchLanguageWithZhAndEn,
  getConstantI18nValue
}
